import React from 'react';

import styles from './MobileDeliveryByCompanies.module.css'
import {Button} from "../../../../../../../ui/General/Button/Button.tsx";
import {Order} from "../../../../../../../types/Order.interface.ts";

interface Props {
    offer: Order,
}

export const MobileDeliveryByCompanies: React.FC<Props> = ({ offer,}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.settings}>
                <h4>Выберите компанию</h4>
                <Button type='text'>
                    Изменить
                </Button>
            </div>
            <ul className={styles.offers}>
                {offer.delivery.offers.map(({id, name}) => {
                    if(offer.delivery.company.id === id)
                        return (
                        <li className={styles.offer}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.price}></div>
                            {/*<div className={styles.offerExtraInfo}>*/}
                            {/*    Посылка склад дверь*/}
                            {/*</div>*/}
                            <div className={styles.outline}/>
                        </li>
                    )}
                )}
            </ul>
        </div>
    );
};